import { IActionsDropdown } from '../types/tableDropdown';

export const ACTIONS_DROPDOWN_DIVIDER: IActionsDropdown = { isDivider: true };

// Joins groups of action buttons with a divider between them, skipping any
// group emptied out by permission checks so a divider never ends up leading,
// trailing, or doubled up next to another one.
export const joinActionGroups = (...groups: IActionsDropdown[][]): IActionsDropdown[] => {
  const nonEmptyGroups = groups.filter((group) => group.length > 0);

  return nonEmptyGroups.flatMap((group, index) => (index === 0 ? group : [ACTIONS_DROPDOWN_DIVIDER, ...group]));
};
